import { render, staticRenderFns } from "./TableWithTabs.vue?vue&type=template&id=21a02819&scoped=true&"
import script from "./TableWithTabs.vue?vue&type=script&lang=js&"
export * from "./TableWithTabs.vue?vue&type=script&lang=js&"
import style0 from "./TableWithTabs.vue?vue&type=style&index=0&id=21a02819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a02819",
  null
  
)

export default component.exports